import React, {useEffect, useRef, useState} from "react";
import "../../../styles/products-styling/cleaned/product.css";
import HeaderComponent from "../headerComponent";
import InformationCard from "../informationCard";
import HorizontalMiniCards from "../horizontalMiniCards";
import Divider from "../../generalComponents/divider";
import CTABanner from "../../generalComponents/banners/CTABanner";
import AdvanceCTABanner from "../../generalComponents/banners/advanceCTABanner";
import {BuiltForShopifyBadge, FacebookAdGraphic1, FacebookAdGraphic2, FacebookAdGraphic3} from "../../../assets/assets";
import {ArrowRightIcon} from "@heroicons/react/16/solid";
import {useLocation} from "react-router-dom";
import TestimonialComponent from "../../home/TestimonialComponent";
import TestimonialsSection from "../testimonialsSection";
import {sendSlackMessageTracked} from "../../../models/notifications";
import SecondaryPricingComponent from "../../SecondaryPricingComponent";
import ModernPricingView from "../../pricing/modernPricingView";
import CarouselComponent from "../../CarouselComponent";
import MainPopupForm from "../../popupModules/mainPopupForm";

const CashbackSuccessComponent = () => {
  const location = useLocation();
  
    const [hash, setHash] = useState();
  
    useEffect(() => {
      const hash = location.hash;
      setHash(hash)
      sendSlackMessageTracked("Lead is visiting the Cashback Success page.", "#website-updates")
    });
  
    // Scroll handler
    useEffect(() => {
      let referenceObject = null;
      let blockPosition = "center"
      
    }, [hash]);
  
  
    return (
     <div
        className="page-template page-template-elementor_header_footer page
        page-id-1652 wp-custom-logo elementor-default
        elementor-template-full-width elementor-kit-159 elementor-page
        elementor-page-1652"
        // style={{ background: `#f9fafb` }}
      >
        <div
            data-elementor-type="wp-page"
            data-elementor-id={1652}
            className="elementor elementor-1652"
            data-elementor-post-type="page"
        >
          <HeaderComponent title="5 biggest businesses using Cashback in 2025 and how to copy them with Shopify."
                           
                           subtitle={<div>9 of 10 Shopify dentists recommend this app. But first, what’s a Shopify dentist?
                           </div>}
                           items={[
                               {text: "💸 Cashback", ctaURL: "#cashback"},
                               {text: "💰 Rebate", ctaURL: "#rebate"},
                               {text: "💰 Discount", ctaURL: "#discounts"},

                           ]}
          />
  
          <div className="space-y-12 mb-8">
            <InformationCard
                // image="https://planzer.io/wp-content/uploads/2023/01/62d5698a920dec3f3e45bcbf_tasks-solved.svg"
                // image={FacebookAdGraphic3}
                // image="https://people.com/thmb/-Fk7xpHk6czhl9v3qm3hNtE3wxE=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc():focal(900x447:902x449)/starbucks-customers-coffee-011425-2a276c1cdc274c508a79e3cf9ac0380b.jpg"
                image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSG8WZf9UiXVeq_F9okWghl83yYojjYeX1nWQ&s"
                // imageDirection="left"
                imageDirection="right"
                text="☕️ Starbucks "
                ctaURL="/products/cashback"
                ctaString="Learn more about Cashback"
                subtext={
                  <div>
                    Starbucks Rewards drives over 50% of U.S. in-store sales, according to company earnings. Customers earn stars (store credit) on every purchase, which they can
                     redeem later—creating habits and daily visits. The result? A loyalty engine that generates over $1.6 billion in pre-loaded rewards balances, locking spend inside their ecosystem
                    <br/><br/>
                  </div>
                }
            />
  
  <InformationCard
                // image="https://planzer.io/wp-content/uploads/2023/01/62d5698a920dec3f3e45bcbf_tasks-solved.svg"
                // image={FacebookAdGraphic3}
                image="https://web.archive.org/web/20230420133841im_/https://cdn.shopify.com/shopifycloud/brochure/assets/merchants/snowdevil/snowdevil-about-online-store-sustainability@desktop-2x-58cb709c01464fee88750e78a3ea221c1f9e05c07611a2be28dd43bcfa80ab39.png"
                // imageDirection="left"
                imageDirection="left"
                text="📚 Amazon "
                ctaURL="/products/cashback"
                ctaString="Learn more about Cashback"
                subtext={
                  <div>
                    Amazon Prime Visa cardholders earn 5% cashback on Amazon purchases. This rewards model contributes to over 200 million Prime subscribers globally, many of whom shop more than twice as often as 
                    non-Prime users. Cashback is seamlessly tied to accounts, keeping value internal and repeat purchases high.
                    
                  </div>
                }
            />
  
  <InformationCard
                // image="https://planzer.io/wp-content/uploads/2023/01/62d5698a920dec3f3e45bcbf_tasks-solved.svg"
                // image={FacebookAdGraphic3}
                image="https://web.archive.org/web/20230420133841im_/https://cdn.shopify.com/shopifycloud/brochure/assets/merchants/snowdevil/snowdevil-about-online-store-sustainability@desktop-2x-58cb709c01464fee88750e78a3ea221c1f9e05c07611a2be28dd43bcfa80ab39.png"
                // imageDirection="left"
                imageDirection="right"
                text="🧥 Fashion Retailers "
                ctaURL="/products/cashback"
                ctaString="Learn more about Cashback"
                subtext={
                  <div>
                    Macy’s credit card loyalty program accounts for nearly 55% of their annual sales. Through seasonal cashback and “Star Rewards,” customers are incentivized to return and spend more, especially during high-stakes events 
                    like Black Friday. Shoppers with the Macy’s card spend on average 2x more than non-cardholders.
                    
                  </div>
                }
            />
  
  
         <div className="flex justify-center">
                      <CTABanner
                          text="Ready to start planning your cashback?" ctaURL="/pricing" ctaString="Select program"
                      />
                    </div>

                    <div className="">
            <ModernPricingView/>
          </div>
  
          <div className="mb-8 mt-2">
            <CarouselComponent />
          </div>
    
            </div>
          </div>
        </div>
      
    );
  };

export default CashbackSuccessComponent;
